export type ReportProblemState = {
    loading: boolean;
};

export const ReportProblemInitialState: ReportProblemState = {
    loading: false,
};